import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, BookOpen, Brain, Zap } from 'lucide-react';
export function SystemPromise() {
  const cards = [{
    icon: Stethoscope,
    title: 'Evaluaciones organizadas',
    desc: 'Anamnesis, inspección y test, ordenados como en la clínica real.'
  }, {
    icon: BookOpen,
    title: 'Protocolos y pruebas clínicas',
    desc: 'Tests ortopédicos con su interpretación, sin más resúmenes sueltos.'
  }, {
    icon: Brain,
    title: 'Casos clínicos aplicados',
    desc: 'Aprendés a razonar y conectar teoría con práctica concreta.'
  }, {
    icon: Zap,
    title: 'Pensado para prácticas reales',
    desc: 'Material útil para parciales, internado y atención de pacientes.'
  }];
  return <section className="relative overflow-hidden bg-navy-950 border-b border-white/5 py-12 sm:py-20 md:py-24" data-id="element-409">
      {/* Subtle grid texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-410">
        <div className="absolute inset-0" style={{
        backgroundImage: 'linear-gradient(rgba(201,168,76,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.4) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} data-id="element-411" />
      </div>

      {/* Soft ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-gold/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-412"></div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-414">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-[9px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-4 sm:mb-5" data-id="element-415">
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-416"></span>
            <span data-id="element-417">Qué es el Mega Pack</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="font-heading font-extrabold text-white leading-[1.05] tracking-tight text-3xl sm:text-4xl md:text-5xl mb-3 sm:mb-4" data-id="element-418">
            No es solo un{' '}
            <span className="font-editorial italic text-gold/80 font-medium" data-id="element-419">
              pack de PDFs
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed px-2" data-id="element-420">
            Es un{' '}
            <span className="text-white font-semibold" data-id="element-421">
              sistema clínico organizado
            </span>{' '}
            para ayudarte a relacionar teoría con práctica real y estudiar con{' '}
            <span className="font-editorial italic text-gold/90" data-id="element-422">
              mucha más claridad
            </span>
            .
          </motion.p>
        </div>

        {/* Mini cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-423">
          {cards.map((card, idx) => {
          const Icon = card.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 + idx * 0.06
          }} className="group relative bg-gradient-to-b from-navy-900/80 to-navy-950/80 backdrop-blur-sm border border-white/[0.06] hover:border-gold/30 rounded-2xl p-4 sm:p-5 transition-all duration-300" data-id="element-424">
                {/* Soft clinical glow on hover */}
                <div className="absolute inset-0 bg-gold/[0.04] opacity-0 group-hover:opacity-100 rounded-2xl blur-xl pointer-events-none transition-opacity duration-500" data-id="element-425"></div>

                <div className="relative flex items-start gap-3 sm:gap-4" data-id="element-426">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center shadow-[0_0_20px_rgba(201,168,76,0.15)]" data-id="element-427">
                    <Icon size={18} className="text-gold" strokeWidth={2} data-id="element-428" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-429">
                    <h3 className="font-heading font-bold text-white text-sm sm:text-base leading-tight mb-1" data-id="element-430">
                      {card.title}
                    </h3>
                    <p className="text-[12px] sm:text-sm text-gray-400 leading-relaxed" data-id="element-431">
                      {card.desc}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}